class ClosableElement {
    constructor(el, callback) {
        this._init(el, callback)
    }
    _init(el, callback) {
        var clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his childrens
            if(!Array.isArray(el)) {
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    callback();
                }
            } else {
                var contains = false;
                el.forEach(element => {
                    contains = contains || element == event.target || element.contains(event.target)
                })

                if(!contains) {
                    callback();
                }
            }
        }
        document.body.addEventListener('click', clickOutsideEvent);
        document.body.addEventListener('touchstart', clickOutsideEvent);
    }
}

export default ClosableElement